import * as React from 'react';
import DeleteConfirmation from "../../Components/DeleteConfirmation";

function DeleteTransaction(props) {
    return (
        <DeleteConfirmation
            id={props.id}
            title={'Usuń transakcje'}
            subtitle={'Czy na pewno chcesz usunąć dane tej transakcji?'}
            url={'/api/transaction'}
            onSuccess={props.onSuccess}
        />
    )
}

export default DeleteTransaction;